// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5858) return "static/chunks/5858-9cc55ff9012b0be6.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"912":"7204343276e77e5f","8563":"7c2c8dc45ea04e9c"}[chunkId] + ".js";
};